import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "status-wrapper" }
const _hoisted_2 = { class: "status-bar" }

import { onUnmounted } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/shared/Icon.vue";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import TimelineStepDescription from "@/components/timeline/TimelineStepDescription.vue";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import { ProductIds } from "@/config/constants";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { TimelineMilestoneIds } from "@/models/applicationStatus";

export default /*@__PURE__*/_defineComponent({
  __name: 'RightToCancelPeriod',
  emits: ["todoListClicked", "cancelApplication", "closeCancellationForm"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const emit = __emit;

const { timeline, useV2, currentstep, selectedStep, stepCount, productTypeId } =
  useApplicationStatus();

onUnmounted(() => {
  store.dispatch("applicationStatusModule/resetState");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeline), (step) => {
        return (_openBlock(), _createBlock(TimelineStep, {
          key: step.id,
          status: step.status,
          step: step.step,
          title: step.title,
          maximumStep: _unref(stepCount),
          configuration: step,
          onTitleClicked: _cache[0] || (_cache[0] = ($event: any) => (currentstep.value = $event)),
          onTodoListClicked: _cache[1] || (_cache[1] = ($event: any) => (emit('todoListClicked')))
        }, _createSlots({ _: 2 }, [
          (
            _unref(productTypeId) === _unref(ProductIds).REFI &&
            step.id === _unref(TimelineMilestoneIds).RIGHT_TO_CANCEL_PERIOD
          )
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createTextVNode("Right To Cancel Period", -1)),
                  _createVNode(TooltipComponent, null, {
                    toggle: _withCtx(() => [
                      _createVNode(Icon, { icon: "info" })
                    ]),
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("div", null, " You have a right to cancel this transaction, without penalty, by the Right To Cancel Date shown on your Final Disclosure. No funds will be disbursed until after this time. You may cancel by clicking the “Cancel Application” link above. ", -1))
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined,
          (_unref(useV2) && _unref(currentstep) === step.step)
            ? {
                name: "caption",
                fn: _withCtx(() => [
                  _createVNode(TimelineStepDescription, {
                    class: "mobile",
                    step: step.step,
                    status: _unref(selectedStep).status
                  }, null, 8, ["step", "status"])
                ]),
                key: "1"
              }
            : undefined
        ]), 1032, ["status", "step", "title", "maximumStep", "configuration"]))
      }), 128))
    ]),
    (_unref(useV2))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "divider" }, null, -1)),
          _createVNode(TimelineStepDescription, {
            step: _unref(selectedStep).step,
            status: _unref(selectedStep).status
          }, null, 8, ["step", "status"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})